
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Contributor {
  id: string;
  username: string;
  avatar_url: string | null;
  role?: 'creator' | 'contributor';
}

export const useContributors = () => {
  const [searchResults, setSearchResults] = useState<Contributor[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  const searchUsers = async (searchTerm: string) => {
    if (!searchTerm.trim() || searchTerm.length < 2) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    try {
      const { data, error } = await supabase.rpc('search_users_for_mention', {
        search_term: searchTerm
      });

      if (error) {
        console.error('Error searching users:', error);
        setSearchResults([]);
      } else {
        setSearchResults(data || []);
      }
    } catch (error) {
      console.error('Error searching users:', error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  return {
    searchResults,
    isSearching,
    searchUsers
  };
};
